import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ViewChild,
  ViewChildren,
  QueryList,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { DemandeValidation } from '@models/api/responses';
import { PagedResultDTO } from '@models/shared';
import { FilterParams } from '@models/api/requests';
import { ValidationDemandesService } from 'src/app/core/services/validation-demandes.service';
import { MAT_RADIO_DEFAULT_OPTIONS, MatRadioModule } from '@angular/material/radio';

import { MatDialog } from '@angular/material/dialog';
import { PdfViewerComponent } from 'src/app/shared/pdf-viewer/pdf-viewer.component';
import { DataTableOptimizedComponent } from 'src/app/shared/data-table-optimized/data-table-optimized.component';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';
import { DemandeType, Role, StatusAvis } from '@models/enums';
import { DemandeStatusService } from 'src/app/core/services/demande-status.service';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { FilterControlsComponent } from '../consultation/filter-controls/filter-controls.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomLuxonDateAdapter } from 'src/app/shared/utils/custom-luxon-date-adapter';
import { MY_FORMATS } from 'src/app/shared/utils/date-pickr-custom-luxon-format';
import { ToastrService } from 'ngx-toastr';
import { ToastrDownloadService } from 'src/app/services/toastr-download.service';
import { ExcelService } from 'src/app/core/services/excel.service';
import { RecallActionDialogComponent } from 'src/app/shared/pdf-viewer/recall-action-dialog/recall-action-dialog.component';
import { RoleService } from 'src/app/core/services/role.service';
import { ValidationModalComponent } from 'src/app/shared/validation-modal/validation-modal.component';

type PanelName = 'Recrutement' | 'RecrutementValidees' | 'RecrutementRefusees' | 'RecrutementVoirTout';
type PanelStateName = 'Renouvellement' | 'RenouvellementValidees' | 'RenouvellementRefusees' | 'RenouvellementVoirTout';
@Component({
    selector: 'app-validation-demandes',
    imports: [
        CommonModule,
        MatTabsModule,
        MatDividerModule,
        DataTableOptimizedComponent,
        FilterControlsComponent,
        MatIconModule,
        MatButtonModule,
        MatSnackBarModule,
        MatRadioModule,
        FormsModule,
        MatExpansionModule
    ],
    templateUrl: './validation-demandes.component.html',
    styleUrls: ['./validation-demandes.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
        { provide: DateAdapter, useClass: CustomLuxonDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        {
            provide: MAT_RADIO_DEFAULT_OPTIONS,
            useValue: { color: 'primary' }
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ValidationDemandesComponent implements OnInit, OnDestroy {
  @ViewChildren(DataTableOptimizedComponent) dataTables!: QueryList<DataTableOptimizedComponent>;
  @ViewChild('enAttenteTable') enAttenteTable: DataTableOptimizedComponent;
  @ViewChild('validees') validees: DataTableOptimizedComponent;
  @ViewChild('refusees') refusees: DataTableOptimizedComponent;
  @ViewChild('voirTout') voirTout: DataTableOptimizedComponent;
  //@ViewChild('activeTable') activeTable: DataTableOptimizedComponent;
  @ViewChild('activeTableRenouvellementEnAttente') activeTableRenouvellementEnAttente: DataTableOptimizedComponent;
  @ViewChild('activeTableRenouvellementValidees') activeTableRenouvellementValidees: DataTableOptimizedComponent;
  @ViewChild('activeTableRenouvellementRefusees') activeTableRenouvellementRefusees: DataTableOptimizedComponent;
  @ViewChild('activeTableRenouvellementVoirTout') activeTableRenouvellementVoirTout: DataTableOptimizedComponent;
  @ViewChildren(FilterControlsComponent) filterControls: QueryList<FilterControlsComponent>;

  arianeLabel: string = 'Validation des demandes';
  arianeIcon: string = 'check_circle';
  arianeList = [
    {
      label: 'Validation des demandes',
      url: '/pama/validation-demandes'
    }
  ];

  countDemandeRecrutement: number = 0;
  countDemandeRenouvellement: number = 0;

  countRecrutementEnAttente: number = 0;
  countRecrutementValidees: number = 0;
  countRecrutementRefusees: number = 0;
  countRecrutementTotal: number = 0;

  countRenouvellementEnAttente: number = 0;
  countRenouvellementValidees: number = 0;
  countRenouvellementRefusees: number = 0;
  countRenouvellementTotal: number = 0;

  demandesDisplayedColumns: string[] = [
    'Emetteur de la demande',
    'Type de recrutement',
    'Direction',
    'Service',
    'N° de poste',
    'Date de création',
    'Statut',
    'Actions'
  ];

  demandesRenouvellementDisplayedColumns: string[] = [
    'Emetteur de la demande',
    'Type de renouvellement',
    'Direction',
    'Service',
    'N° de poste',
    'Agent à renouveler',
    'Date de création',
    'Statut',
    'Actions'
  ];

  demandesDisplayedColumnsNoSelect: string[] = [
    'Emetteur de la demande',
    'Type de recrutement',
    'Direction',
    'Service',
    'N° de poste',
    'Date de création',
    'Statut',
    'Actions'
  ];

  demandesRenouvellementDisplayedColumnsNoSelect: string[] = [
    'Emetteur de la demande',
    'Type de renouvellement',
    'Direction',
    'Service',
    'N° de poste',
    'Agent à renouveler',
    'Date de création',
    'Statut',
    'Actions'
  ];

  demandesCellStyleCss: any = {
    Statut: { 'text-align': 'center' },
    'Date création': { 'text-align': 'center' }
  };

  demandesHeaderStyleCss: any = {
    Statut: { display: 'flex', 'justify-content': 'center' }
  };

  panelOpenStateRecrutement: boolean = false;
  panelOpenStateRecrutementValidees: boolean = false;
  panelOpenStateRecrutementRefusees: boolean = false;
  panelOpenStateRecrutementVoirTout: boolean = false;

  panelOpenStateRenouvellement: boolean = false;
  panelOpenStateRenouvellementValidees: boolean = false;
  panelOpenStateRenouvellementRefusees: boolean = false;
  panelOpenStateRenouvellementVoirTout: boolean = false;

  filtrerLibelles$: { [key: string]: Observable<string> } = {};

  selectedTabIndex: number = 0;
  pipe = new DatePipe('fr-FR');
  isRecrutementActive: boolean = true;
  recrutementData = [];
  renouvellementData = [];
  isAdmin: boolean = false;

  filterSubjectRecrutement = new BehaviorSubject<FilterParams | null>({
    emetteur: null,
    direction: null,
    serviceFonctionnel: null,
    numeroPoste: null,
    agentRenouvele: null,
    typeDemande: DemandeType.Recrutement,
    dateCreationStart: null,
    dateCreationEnd: null,
    statut: null,
    typeRecrutement: null,
    typeRenouvellement: null
  });
  filterSubjectRecrutementValidees = new BehaviorSubject<FilterParams | null>({
    emetteur: null,
    direction: null,
    serviceFonctionnel: null,
    numeroPoste: null,
    agentRenouvele: null,
    typeDemande: DemandeType.Recrutement,
    dateCreationStart: null,
    dateCreationEnd: null,
    statut: null,
    typeRecrutement: null,
    typeRenouvellement: null
  });
  filterSubjectRecrutementRefusees = new BehaviorSubject<FilterParams | null>({
    emetteur: null,
    direction: null,
    serviceFonctionnel: null,
    numeroPoste: null,
    agentRenouvele: null,
    typeDemande: DemandeType.Recrutement,
    dateCreationStart: null,
    dateCreationEnd: null,
    statut: null,
    typeRecrutement: null,
    typeRenouvellement: null
  });
  filterSubjectRecrutementVoirTout = new BehaviorSubject<FilterParams | null>({
    emetteur: null,
    direction: null,
    serviceFonctionnel: null,
    numeroPoste: null,
    agentRenouvele: null,
    typeDemande: DemandeType.Recrutement,
    dateCreationStart: null,
    dateCreationEnd: null,
    statut: null,
    typeRecrutement: null,
    typeRenouvellement: null
  });

  filterSubjectRenouvellement = new BehaviorSubject<FilterParams | null>({
    emetteur: null,
    direction: null,
    serviceFonctionnel: null,
    numeroPoste: null,
    agentRenouveleId: null,
    typeDemande: DemandeType.Renouvellement,
    dateCreationStart: null,
    dateCreationEnd: null,
    statut: null,
    typeRecrutement: null,
    typeRenouvellement: null
  });
  filterSubjectRenouvellementValidees = new BehaviorSubject<FilterParams | null>({
    emetteur: null,
    direction: null,
    serviceFonctionnel: null,
    numeroPoste: null,
    agentRenouveleId: null,
    typeDemande: DemandeType.Renouvellement,
    dateCreationStart: null,
    dateCreationEnd: null,
    statut: null,
    typeRecrutement: null,
    typeRenouvellement: null
  });
  filterSubjectRenouvellementRefusees = new BehaviorSubject<FilterParams | null>({
    emetteur: null,
    direction: null,
    serviceFonctionnel: null,
    numeroPoste: null,
    agentRenouveleId: null,
    typeDemande: DemandeType.Renouvellement,
    dateCreationStart: null,
    dateCreationEnd: null,
    statut: null,
    typeRecrutement: null,
    typeRenouvellement: null
  });
  filterSubjectRenouvellementVoirTout = new BehaviorSubject<FilterParams | null>({
    emetteur: null,
    direction: null,
    serviceFonctionnel: null,
    numeroPoste: null,
    agentRenouveleId: null,
    typeDemande: DemandeType.Renouvellement,
    dateCreationStart: null,
    dateCreationEnd: null,
    statut: null,
    typeRecrutement: null,
    typeRenouvellement: null
  });
  demandes: any[] = [];
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly validationDemandesService: ValidationDemandesService,
    private readonly dialog: MatDialog,
    private readonly snackBar: MatSnackBar,
    private readonly demandeStatusService: DemandeStatusService,
    private readonly route: ActivatedRoute,
    private readonly cdr: ChangeDetectorRef,
    private readonly toastrService: ToastrService,
    private readonly toastrDownloadService: ToastrDownloadService,
    private readonly excelService: ExcelService,
    private readonly roleService: RoleService
  ) {}

  ngOnInit() {
    //Recrutement
    this.initFiltrerLibelle('Recrutement', this.filterSubjectRecrutement);
    this.initFiltrerLibelle('RecrutementValidees', this.filterSubjectRecrutementValidees);
    this.initFiltrerLibelle('RecrutementRefusees', this.filterSubjectRecrutementRefusees);
    this.initFiltrerLibelle('RecrutementVoirTout', this.filterSubjectRecrutementVoirTout);
    //Renouvellement
    this.initFiltrerLibelle('Renouvellement', this.filterSubjectRenouvellement);
    this.initFiltrerLibelle('RenouvellementValidees', this.filterSubjectRenouvellementValidees);
    this.initFiltrerLibelle('RenouvellementRefusees', this.filterSubjectRenouvellementRefusees);
    this.initFiltrerLibelle('RenouvellementVoirTout', this.filterSubjectRenouvellementVoirTout);

    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.isRecrutementActive = params['isRenouvellement'] !== 'true';
      this.cdr.detectChanges();
    });

    this.roleService
      .getRole()
      .pipe(takeUntil(this.destroy$))
      .subscribe((roles) => {
        this.isAdmin = roles.includes(Role.PAMA_ADMIN);
        this.cdr.detectChanges();
        this.refreshAllTables();
      });

    // Load all counts when component initializes
    this.loadAllCounts();
  }

  // Load all counters for all tabs proactively
  loadAllCounts() {
    // Get filters
    const filterRecrutement = this.filterSubjectRecrutement.value || {};
    const filterRenouvellement = this.filterSubjectRenouvellement.value || {};
    const filterRecrutementValidees = this.filterSubjectRecrutementValidees.value || {};
    const filterRenouvellementValidees = this.filterSubjectRenouvellementValidees.value || {};
    const filterRecrutementRefusees = this.filterSubjectRecrutementRefusees.value || {};
    const filterRenouvellementRefusees = this.filterSubjectRenouvellementRefusees.value || {};
    const filterRecrutementVoirTout = this.filterSubjectRecrutementVoirTout.value || {};
    const filterRenouvellementVoirTout = this.filterSubjectRenouvellementVoirTout.value || {};

    // Load all counts in parallel with their respective filters
    this.getDemandesRecrutementEnAttente(0, 1, filterRecrutement as FilterParams)
      .pipe(take(1))
      .subscribe();
    this.getDemandesRenouvellementEnAttente(0, 1, filterRenouvellement as FilterParams)
      .pipe(take(1))
      .subscribe();
    this.getDemandesRecrutementValidees(0, 1, filterRecrutementValidees as FilterParams)
      .pipe(take(1))
      .subscribe();
    this.getDemandesRenouvellementValidees(0, 1, filterRenouvellementValidees as FilterParams)
      .pipe(take(1))
      .subscribe();
    this.getDemandesRecrutementRefusees(0, 1, filterRecrutementRefusees as FilterParams)
      .pipe(take(1))
      .subscribe();
    this.getDemandesRenouvellementRefusees(0, 1, filterRenouvellementRefusees as FilterParams)
      .pipe(take(1))
      .subscribe();
    this.getDemandesRecrutementTotal(0, 1, filterRecrutementVoirTout as FilterParams)
      .pipe(take(1))
      .subscribe();
    this.getDemandesRenouvellementTotal(0, 1, filterRenouvellementVoirTout as FilterParams)
      .pipe(take(1))
      .subscribe();

    // Mark for check after initiating all requests
    this.cdr.markForCheck();
  }

  // Simplified loadCounts for tab changes - now calls loadAllCounts
  loadCounts() {
    this.loadAllCounts();
  }

  //Refactor method to generate observable filterLibelle
  initFiltrerLibelle(nom: string, subject: BehaviorSubject<FilterParams | null>) {
    this.filtrerLibelles$[nom] = subject.pipe(
      map((filters) => {
        const activeFilters = [
          filters?.emetteur,
          filters?.direction,
          filters?.serviceFonctionnel,
          filters?.numeroPoste,
          filters?.agentRenouveleId || filters?.agentRenouvele,
          filters?.dateCreationStart && filters?.dateCreationEnd,
          filters?.statut,
          filters?.typeRecrutement,
          filters?.typeRenouvellement
        ].filter(Boolean).length;

        return activeFilters > 0 ? `Filtrer (${activeFilters})` : 'Filtrer';
      })
    );
  }

  //Recrutement
  get filtrer_libelleRecrutement$(): Observable<string> {
    return this.filtrerLibelles$['Recrutement'];
  }
  get filtrer_libelleRecrutementValidees$(): Observable<string> {
    return this.filtrerLibelles$['RecrutementValidees'];
  }
  get filtrer_libelleRecrutementRefusees$(): Observable<string> {
    return this.filtrerLibelles$['RecrutementRefusees'];
  }
  get filtrer_libelleRecrutementVoirTout$(): Observable<string> {
    return this.filtrerLibelles$['RecrutementVoirTout'];
  }
  //Renouvellement
  get filtrer_libelleRenouvellement$(): Observable<string> {
    return this.filtrerLibelles$['Renouvellement'];
  }
  get filtrer_libelleRenouvellementValidees$(): Observable<string> {
    return this.filtrerLibelles$['RenouvellementValidees'];
  }
  get filtrer_libelleRenouvellementRefusees$(): Observable<string> {
    return this.filtrerLibelles$['RenouvellementRefusees'];
  }
  get filtrer_libelleRenouvellementVoirTout$(): Observable<string> {
    return this.filtrerLibelles$['RenouvellementVoirTout'];
  }

  onFilterAppliedRecrutementGlobal(formValues: any, tableName: string) {
    const startDate = formValues.dateCreation ? this.pipe.transform(formValues.dateCreation, 'yyyy-MM-ddT00:00:00') : null;

    const endDate = formValues.dateCreation
      ? this.pipe.transform(
          new Date(new Date(formValues.dateCreation).setDate(new Date(formValues.dateCreation).getDate() + 1)),
          'yyyy-MM-ddT00:00:00'
        )
      : null;
    const filterParams: FilterParams = {
      emetteur:
        formValues?.emetteur?.nom && formValues?.emetteur?.prenom ? `${formValues.emetteur?.nom} ${formValues.emetteur?.prenom}` : null,
      direction: formValues?.direction?.libelle ?? null,
      serviceFonctionnel: formValues?.serviceFonctionnel?.libelle ?? null,
      numeroPoste: formValues?.numeroPoste?.numero ?? null,
      agentRenouvele: null,
      typeDemande: DemandeType.Recrutement,
      dateCreationStart: startDate,
      dateCreationEnd: endDate,
      statut: formValues.statut ?? null,
      typeRecrutement: formValues?.typeRecrutement?.libelle ?? null,
      typeRenouvellement: null
    };

    if (tableName === 'validees') {
      this.filterSubjectRecrutementValidees.next(filterParams);
    } else if (tableName === 'enAttente') {
      this.filterSubjectRecrutement.next(filterParams);
    } else if (tableName === 'refusees') {
      this.filterSubjectRecrutementRefusees.next(filterParams);
    } else if (tableName === 'voirTout') {
      this.filterSubjectRecrutementVoirTout.next(filterParams);
    }

    this.cdr.detectChanges();
  }

  onFilterAppliedRenouvellementGlobal(formValues: any, refTable: string) {
    const startDate = formValues.dateCreation ? this.pipe.transform(formValues.dateCreation, 'yyyy-MM-ddT00:00:00') : null;

    const endDate = formValues.dateCreation
      ? this.pipe.transform(
          new Date(new Date(formValues.dateCreation).setDate(new Date(formValues.dateCreation).getDate() + 1)),
          'yyyy-MM-ddT00:00:00'
        )
      : null;
    const filterParams: FilterParams = {
      emetteur:
        formValues?.emetteur?.nom && formValues?.emetteur?.prenom ? `${formValues.emetteur?.nom} ${formValues.emetteur?.prenom}` : null,
      direction: formValues?.direction?.libelle ?? null,
      serviceFonctionnel: formValues?.serviceFonctionnel?.libelle ?? null,
      numeroPoste: formValues?.numeroPoste?.numero ?? null,
      agentRenouveleId: formValues?.agentRenouvele?.id ?? null,
      agentRenouvele: this.getAgentRenouveleLibelle(formValues?.agentRenouvele),
      typeDemande: DemandeType.Renouvellement,
      dateCreationStart: startDate,
      dateCreationEnd: endDate,
      statut: formValues.statut ?? null,
      typeRecrutement: null,
      typeRenouvellement: formValues?.typeRenouvellement?.libelle ?? null
    };

    if (refTable === 'renouvellementValidees') {
      this.filterSubjectRenouvellementValidees.next(filterParams);
    } else if (refTable === 'renouvellementEnAttente') {
      this.filterSubjectRenouvellement.next(filterParams);
    } else if (refTable === 'renouvellementRefusees') {
      this.filterSubjectRenouvellementRefusees.next(filterParams);
    } else if (refTable === 'renouvellementVoirTout') {
      this.filterSubjectRenouvellementVoirTout.next(filterParams);
    }

    this.cdr.detectChanges();
  }

  private getAgentRenouveleLibelle(agent: { id?: string | null; nom?: string | null; prenom?: string | null } | null | undefined): string | null {
    if (agent?.id) {
      return null;
    }

    return [agent?.nom, agent?.prenom].filter(Boolean).join(' ').trim() || null;
  }

  onTabChange(event: any) {
    this.selectedTabIndex = event.index;
    this.loadCounts();
  }

  onRadioChange(event: any) {
    if (event.value) {
      this.panelOpenStateRecrutement = false;
    } else {
      this.panelOpenStateRenouvellement = false;
    }
    this.loadCounts();
    this.cdr.detectChanges();
  }

  togglePanel(panel: 'Recrutement' | 'Renouvellement' | PanelName | PanelStateName): void {
    const panelStateKey = `panelOpenState${panel}` as keyof this;

    this[panelStateKey] = !(this[panelStateKey] as boolean) as this[typeof panelStateKey];

    if (panel === 'Recrutement') {
      this.panelOpenStateRenouvellement = false;
    } else if (panel === 'Renouvellement') {
      this.panelOpenStateRecrutement = false;
    }
  }

  resetFilter(subject: BehaviorSubject<FilterParams | null>, type: DemandeType): void {
    subject.next({
      emetteur: null,
      direction: null,
      serviceFonctionnel: null,
      numeroPoste: null,
      agentRenouveleId: null,
      dateCreationStart: null,
      dateCreationEnd: null,
      statut: null,
      typeDemande: type,
      typeRecrutement: null,
      typeRenouvellement: null
    });
    this.cdr.detectChanges();
  }

  resetAllFilters(subjects: BehaviorSubject<FilterParams | null>[], type: DemandeType): void {
    subjects.forEach((subject) => this.resetFilter(subject, type));
  }

  resetAllFiltersRecrutement(): void {
    this.resetAllFilters(
      [
        this.filterSubjectRecrutement,
        this.filterSubjectRecrutementValidees,
        this.filterSubjectRecrutementRefusees,
        this.filterSubjectRecrutementVoirTout
      ],
      DemandeType.Recrutement
    );
  }

  resetAllFiltersRenouvellement(): void {
    this.resetAllFilters(
      [
        this.filterSubjectRenouvellement,
        this.filterSubjectRenouvellementValidees,
        this.filterSubjectRenouvellementRefusees,
        this.filterSubjectRenouvellementVoirTout
      ],
      DemandeType.Renouvellement
    );
  }

  getDemandesRecrutementEnAttente = (pageIndex: number, pageSize: number, filter?: FilterParams): Observable<PagedResultDTO<any>> => {
    return this.validationDemandesService.getDemandesAValider(pageIndex, pageSize, filter).pipe(
      map((response) => {
        this.countRecrutementEnAttente = response.totalRecords;
        this.cdr.detectChanges();
        return {
          ...response,
          results: this.transformData_demandes(response.results, false)
        };
      })
    );
  };
  getDemandesRenouvellementEnAttente = (pageIndex: number, pageSize: number, filter?: FilterParams): Observable<PagedResultDTO<any>> => {
    return this.validationDemandesService.getDemandesAValider(pageIndex, pageSize, filter).pipe(
      map((response) => {
        this.countRenouvellementEnAttente = response.totalRecords;
        this.cdr.detectChanges();
        return {
          ...response,
          results: this.transformData_demandes(response.results, true)
        };
      })
    );
  };

  getDemandesRecrutementValidees = (pageIndex: number, pageSize: number, filter?: FilterParams): Observable<PagedResultDTO<any>> => {
    return this.validationDemandesService.getDemandesValidees(pageIndex, pageSize, filter).pipe(
      map((response) => {
        this.countRecrutementValidees = response.totalRecords;
        return {
          ...response,
          results: this.transformData_demandes(response.results)
        };
      })
    );
  };

  getDemandesRenouvellementValidees = (pageIndex: number, pageSize: number, filter?: FilterParams): Observable<PagedResultDTO<any>> => {
    return this.validationDemandesService.getDemandesValidees(pageIndex, pageSize, filter).pipe(
      map((response) => {
        this.countRenouvellementValidees = response.totalRecords;
        return {
          ...response,
          results: this.transformData_demandes(response.results)
        };
      })
    );
  };

  getDemandesRenouvellementRefusees = (pageIndex: number, pageSize: number, filter?: FilterParams): Observable<PagedResultDTO<any>> => {
    return this.validationDemandesService.getDemandesRefusees(pageIndex, pageSize, filter).pipe(
      map((response) => {
        this.countRenouvellementRefusees = response.totalRecords;
        return {
          ...response,
          results: this.transformData_demandes(response.results)
        };
      })
    );
  };
  getDemandesRecrutementRefusees = (pageIndex: number, pageSize: number, filter?: FilterParams): Observable<PagedResultDTO<any>> => {
    return this.validationDemandesService.getDemandesRefusees(pageIndex, pageSize, filter).pipe(
      map((response) => {
        this.countRecrutementRefusees = response.totalRecords;
        return {
          ...response,
          results: this.transformData_demandes(response.results)
        };
      })
    );
  };

  getDemandesRecrutementTotal = (pageIndex: number, pageSize: number, filter?: FilterParams): Observable<PagedResultDTO<any>> => {
    return this.validationDemandesService.getAllDemandes(pageIndex, pageSize, filter).pipe(
      map((response) => {
        this.countRecrutementTotal = response.totalRecords;
        return {
          ...response,
          results: this.transformData_demandes(response.results)
        };
      })
    );
  };
  getDemandesRenouvellementTotal = (pageIndex: number, pageSize: number, filter?: FilterParams): Observable<PagedResultDTO<any>> => {
    return this.validationDemandesService.getAllDemandes(pageIndex, pageSize, filter).pipe(
      map((response) => {
        this.countRenouvellementTotal = response.totalRecords;
        return {
          ...response,
          results: this.transformData_demandes(response.results)
        };
      })
    );
  };

  refreshAllTables() {
    this.dataTables?.forEach((table) => {
      table.refresh();
    });
  }

  showDetails(element: DemandeValidation) {
    this.dialog
      .open(PdfViewerComponent, {
        width: '2000px',
        height: '100%',
        maxWidth: '100vw',
        panelClass: 'dialog-bg-trans',
        data: {
          demandes: [{ id: element.id, type: element.typeDemande }],
          filename: `demande-${element.id}`,
          action: 'view'
        }
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result === 'refresh') {
          this.refreshAllTables();
        }
      });
  }

  avisDemande(element: DemandeValidation) {
    this.dialog
      .open(PdfViewerComponent, {
        width: '2000px',
        height: '100%',
        maxWidth: '100vw',
        panelClass: 'dialog-bg-trans',
        data: {
          demandes: [{ id: element.id, type: element.typeDemande }],
          filename: `demande-${element.id}`,
          action: 'advice'
        }
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result === 'refresh') {
          this.refreshAllTables();
        }
      });
  }

  validerDemande(element: DemandeValidation) {
    this.dialog
      .open(PdfViewerComponent, {
        width: '2000px',
        height: '100%',
        maxWidth: '100vw',
        panelClass: 'dialog-bg-trans',
        data: {
          demandes: [{ id: element.id, type: element.typeDemande }],
          filename: `demande-${element.id}`,
          action: 'validate'
        }
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result === 'refresh') {
          this.refreshAllTables();
        }
      });
  }

  refuserDemande(element: DemandeValidation) {
    this.dialog
      .open(PdfViewerComponent, {
        width: '2000px',
        height: '100%',
        maxWidth: '100vw',
        panelClass: 'dialog-bg-trans',
        data: {
          demandes: [{ id: element.id, type: DemandeType[element.typeDemande as keyof typeof DemandeType] }],
          filename: `demande-${element.id}`,
          action: 'refuse'
        }
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result === 'refresh') {
          this.refreshAllTables();
        }
      });
  }

  validerDemandesEnMasse() {
    const selectedDemandes = this.getSelectedDemandes();
    if (selectedDemandes.length === 0) {
      this.snackBar.open('Veuillez sélectionner au moins une demande à valider', 'Fermer', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['warning-snackbar']
      });
      return;
    }

    const pdfDialogRef = this.dialog.open(PdfViewerComponent, {
      width: '2000px',
      height: '100%',
      maxWidth: '100vw',
      panelClass: 'dialog-bg-trans',
      data: {
        demandes: selectedDemandes.map((demande) => ({
          id: demande.id,
          type: demande.typeDemande
        })),
        filename: 'demandes-multiples',
        action: 'validate'
      }
    });

    pdfDialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result === 'refresh') {
          this.refreshAllTables();
        }
      });
  }

  refuserDemandesEnMasse() {
    const selectedDemandes = this.getSelectedDemandes();
    if (selectedDemandes.length === 0) {
      this.snackBar.open('Veuillez sélectionner au moins une demande à refuser', 'Fermer', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['warning-snackbar']
      });
      return;
    }

    const pdfDialogRef = this.dialog.open(PdfViewerComponent, {
      width: '2000px',
      height: '100%',
      maxWidth: '100vw',
      panelClass: 'dialog-bg-trans',
      data: {
        demandes: selectedDemandes.map((demande) => ({
          id: demande.id,
          type: demande.typeDemande
        })),
        filename: 'demandes-multiples',
        action: 'refuse'
      }
    });

    pdfDialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result === 'refresh') {
          this.refreshAllTables();
        }
      });
  }

  reviserDemandesEnMasse() {
    const selectedDemandes = this.isRecrutementActive
      ? this.enAttenteTable?.getSelectedItems?.()
      : this.activeTableRenouvellementEnAttente?.getSelectedItems?.();
    if (!selectedDemandes || selectedDemandes.length === 0) {
      this.snackBar.open('Veuillez sélectionner au moins une demande à réviser', 'Fermer', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['warning-snackbar']
      });
      return;
    }

    const pdfDialogRef = this.dialog.open(PdfViewerComponent, {
      width: '2000px',
      height: '100%',
      maxWidth: '100vw',
      panelClass: 'dialog-bg-trans',
      data: {
        demandes: selectedDemandes.map((demande) => ({
          id: demande.id,
          type: demande.typeDemande
        })),
        filename: 'demandes-multiples',
        action: 'review'
      }
    });

    pdfDialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result === 'refresh') {
          this.refreshAllTables();
        }
      });
  }
  exporterEnMasseRecrutement() {
    this.toastrService.clear();
    this.toastrDownloadService.showToast('Export en cours');

    const selectedItems = this.enAttenteTable.getSelectedItems();
    if (selectedItems.length > 0) {
      const dataToExport = this.transformData_demandesExport(selectedItems);
      this.convertExcel(dataToExport, 'export_validation_recrutement');

      setTimeout(() => {
        this.toastrDownloadService.downloadSuccess();
      }, 2000);

      this.snackBar.open('Export réussi !', 'Fermer', {
        duration: 4000,
        horizontalPosition: 'right',
        verticalPosition: 'top'
      });
    } else {
      this.validationDemandesService
        .getDemandesAValider(0, this.countRecrutementEnAttente, { typeDemande: 'Recrutement' })
        .pipe(take(1))
        .subscribe({
          next: (result) => {
            if (result) {
              let _data_export = this.transformData_demandesExport(result.results);
              this.convertExcel(_data_export, 'export_validation_recrutement');

              setTimeout(() => {
                this.toastrDownloadService.downloadSuccess();
              }, 2000);

              this.snackBar.open('Export réussi !', 'Fermer', {
                duration: 4000,
                horizontalPosition: 'right',
                verticalPosition: 'top'
              });
            }
          },
          error: (error) => {
            this.toastrService.clear();
            this.toastrDownloadService.removeToast();

            this.snackBar.open('Erreur lors de l’export', 'Fermer', {
              duration: 5000,
              horizontalPosition: 'right',
              verticalPosition: 'top'
            });
          }
        });
    }
  }
  exporterEnMasseRenouvellement() {
    this.toastrService.clear();
    this.toastrDownloadService.showToast('Export en cours');

    const selectedItems = this.activeTableRenouvellementEnAttente.getSelectedItems();
    if (selectedItems.length > 0) {
      const dataToExport = this.transformData_demandesExport(selectedItems, 'renouvellement');
      this.convertExcel(dataToExport, 'export_validation_renouvellement');

      setTimeout(() => {
        this.toastrDownloadService.downloadSuccess();
      }, 2000);

      this.snackBar.open('Export réussi !', 'Fermer', {
        duration: 4000,
        horizontalPosition: 'right',
        verticalPosition: 'top'
      });
    } else {
      this.validationDemandesService
        .getDemandesAValider(0, this.countRenouvellementEnAttente, { typeDemande: 'Renouvellement' })
        .pipe(take(1))
        .subscribe({
          next: (result) => {
            if (result) {
              let _data_export = this.transformData_demandesExport(result.results, 'renouvellement');
              this.convertExcel(_data_export, 'export_validation_renouvellement');

              setTimeout(() => {
                this.toastrDownloadService.downloadSuccess();
              }, 2000);

              this.snackBar.open('Export réussi !', 'Fermer', {
                duration: 4000,
                horizontalPosition: 'right',
                verticalPosition: 'top'
              });
            }
          },
          error: (error) => {
            this.toastrService.clear();
            this.toastrDownloadService.removeToast();

            this.snackBar.open('Erreur lors de l’export', 'Fermer', {
              duration: 5000,
              horizontalPosition: 'right',
              verticalPosition: 'top'
            });
          }
        });
    }
  }
  convertExcel(data: any, name: string) {
    const search = '/';
    const replaceWith = '-';
    const date = new Date().toLocaleDateString('en-GB').split(search).join(replaceWith);
    let fileName = `${name}_${date}`;
    this.excelService.exportToExcel(data, `${fileName}.xlsx`, 'Sheet1');
  }
  transformData_demandes(demandes: any[], isRenouvellement: boolean = false): any[] {
    const defaultActions = ['advice', 'validate', 'refuse', 'detail'];
    return demandes.map((demande) => {
      const isRefused = demande.statut?.includes('REFUSEES');
      return {
        ...demande,
        'ID de la demande': demande.id,
        'Emetteur de la demande': demande.emetteur,
        'Type de recrutement': demande.typeDemande === 'Recrutement' ? demande.libelleDetailType || demande.typeDemande : undefined,
        'Type de renouvellement': demande.typeDemande === 'Renouvellement' ? demande.libelleDetailType || demande.typeDemande : undefined,
        Direction: demande.direction ?? '',
        Service: demande.serviceFonctionnel ?? '',
        'N° de poste': demande.numeroPoste ?? '',
        'Agent à renouveler': demande.agentRenouvele ?? '',
        'Date de création': demande.dateCreation ? this.pipe.transform(demande.dateCreation, 'dd/MM/yyyy HH:mm') : 'Date non définie',
        Statut: {
          text: this.demandeStatusService.getStatusText(demande.statut),
          class: this.demandeStatusService.getStatusClass(demande.statut)
        },
        id: demande.id,
        valider_hidden: !this.demandeStatusService.showValidate(demande.statut),
        valider_disabled: false,
        refuser_hidden: !this.demandeStatusService.showReject(demande.statut),
        refuser_disabled: false,
        view_hidden: false,
        view_disabled: false,
        showAdvice: demande.flagDemandeAvis === true,
        statut: demande.statut,
        typeDemande: demande.typeDemande,
        subTable: [],
        recallRefuse_hidden: !this.canRecallRefus(demande),
        actionOrder: isRefused ? ['detail', 'recallRefuse'] : defaultActions
      };
    });
  }
  transformData_demandesExport(demandes: any[], typeDemande: string | null = null): any[] {
    return demandes.map((demande) => {
      const typeColumn =
        typeDemande === 'renouvellement'
          ? { 'Type de renouvellement': demande.libelleDetailType || demande.typeDemande }
          : { 'Type de recrutement': demande.libelleDetailType || demande.typeDemande };

      let ligne: any = {
        'Emetteur de la demande': demande.emetteur,
        ...typeColumn,
        Direction: demande.direction ?? '',
        Service: demande.serviceFonctionnel ?? '',
        'N° de poste': demande.numeroPoste ?? ''
      };

      if (typeDemande == 'renouvellement') {
        ligne['Agent à renouveler'] = demande.agentRenouvele ?? '';
      }

      ligne = {
        ...ligne,
        ...{
          'Date de création': demande.dateCreation ? this.pipe.transform(demande.dateCreation, 'dd/MM/yyyy HH:mm') : 'Date non définie',
          Statut: this.demandeStatusService.getStatusText(demande.statut)
        }
      };

      return ligne;
    });
  }

  getSelectedDemandes(): DemandeValidation[] {
    return this.enAttenteTable.getSelectedItems();
  }

  canRecallRefus(demande: DemandeValidation): boolean {
    if (!this.isAdmin) return false;
    const statut = demande?.statut;
    if (!statut) return false;
    if (statut === StatusAvis.ARCHIVEES || statut.includes(StatusAvis.A_VALIDER)) return false;
    return statut.includes('REFUSEES');
  }

  annulerRefus(demande: DemandeValidation): void {
    if (!this.canRecallRefus(demande)) return;

    this.dialog
      .open(RecallActionDialogComponent, {
        width: '540px',
        data: {
          title: 'Annuler le refus'
        }
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((motif?: string) => {
        if (!motif?.trim()) return;

        this.validationDemandesService
          .rappelerDemande(demande.id, demande.typeDemande as DemandeType, motif.trim())
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: () => {
              this.dialog.open(ValidationModalComponent, {
                width: '600px',
                data: {
                  title: 'Confirmation',
                  content: 'Le refus a été annulé avec succès.',
                  icon: 'success'
                }
              });
              this.refreshAllTables();
              this.loadCounts();
            },
            error: () => {
              this.dialog.open(ValidationModalComponent, {
                width: '600px',
                data: {
                  title: 'Erreur',
                  content: "Une erreur est survenue lors de l'annulation du refus.",
                  icon: 'error'
                }
              });
            }
          });
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
